import type { ICitaAgendamientoAgendar, ITurnos, TGroupedCita } from '@/modules/Agendamiento/interfaces'
import { type Module } from 'vuex'
export interface IAgendamientoStore {
  turnos: Record<string, ITurnos[]>
  citas: ICitaAgendamientoAgendar[]
  citasGrouped: TGroupedCita[]
}
export interface IheaderTitles { title: string, subTitles: string[], showBackButton: boolean }
export interface StateCore {
  cargaDatos: boolean
  drawerRight: boolean
  widgetMedico: boolean
  countMensajes: number
  notificacion: { show: boolean, mensaje: string, tipo: string }
  agendamiento: IAgendamientoStore,
  headerTitles: IheaderTitles
}
const core: Module<StateCore, unknown> = {
  namespaced: true,
  state: (): StateCore => {
    return {
      cargaDatos: false,
      drawerRight: false,
      widgetMedico: false,
      countMensajes: 0,
      notificacion: { show: false, mensaje: '', tipo: '' },
      agendamiento: {
        turnos: {},
        citas: [],
        citasGrouped: []
      },
      headerTitles: { title: '', subTitles: [], showBackButton: false }
    }
  },
  mutations: {
    setDrawerRight(state: StateCore, data: boolean) {
      state.drawerRight = data
    },
    setWidgetMedico(state: StateCore, data: boolean) {
      state.widgetMedico = data
    },
    setCargaDatos(state: StateCore, data: boolean) {
      state.cargaDatos = data
    },
    setCountMensajes(state: StateCore, data: number) {
      state.countMensajes = data
    },
    setNotificacion(state: StateCore, data: boolean) {
      state.notificacion.show = data
    },
    setAgendamiento(state: StateCore, data: IAgendamientoStore) {
      state.agendamiento = data
    },
    setHeader(state: StateCore, data: IheaderTitles) {
      state.headerTitles = data
    },
  },
  getters: {
    drawerRight: (state: StateCore) => {
      return state.drawerRight;
    },
    agendamiento: (state: StateCore) => {
      return state.agendamiento;
    },
  },
  actions: {},
}
export default core

